<template>
  <div v-if="checkIfVLM()" :class="$style.root" class="vw-100 mw-100">
    <VueCarousel :per-page="1"
                 :loop="true"
                 :autoplay="false"
                 :navigate-to="[page, false]"
                 :navigation-enabled="true"
                 :center-mode="true"
                 :space-padding="50"
                 :navigation-prev-label="prevLabel"
                 :navigation-next-label="nextLabel"
                 :pagination-padding="5"
                 :pagination-size="7"
                 pagination-active-color="#c9b67f">
      <Slide v-for="(item, i) in items" :key="i">
        <Card v-bind="item" :class="$style.card"/>
      </Slide>
    </VueCarousel>
  </div>

   <div v-else :class="$style.root" class="vw-100 mw-100">
    <VueCarousel :per-page="1"
                 :loop="true"
                 :autoplay="false"
                 :navigate-to="[page, false]"
                 :navigation-enabled="true"
                 :center-mode="true"
                 :space-padding="50"
                 :navigation-prev-label="prevLabel"
                 :navigation-next-label="nextLabel"
                 :pagination-padding="5"
                 :pagination-size="7"
                 pagination-active-color="#19AC7F">
      <Slide v-for="(item, i) in items" :key="i">
        <Card v-bind="item" :class="$style.card"/>
      </Slide>
    </VueCarousel>
  </div> 
</template>

<script>
  import {Carousel as VueCarousel, Slide} from 'vue-carousel';
  import Card from './Card';
  import arrowLeftIcon from 'assets/arrow-left-icon.svg';
  import arrowRightIcon from 'assets/arrow-right-icon.svg';
  import { getQueryStringParams } from '../../lib/utils';

  export default {
    name: 'Carousel',
    components: {
      Card,
      VueCarousel,
      Slide
    },
    props: {
      items: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        page: 1,
        prevLabel: `<img src="${arrowLeftIcon}" />`,
        nextLabel: `<img src="${arrowRightIcon}" />`,
      }
    },
    mounted() {
      this.page = 0;
    },
     methods: {
      checkIfVLM(){
        const params = getQueryStringParams(); 
        return params && params['shoppingSlug'] === 'vlm';
      },
    }
  }
</script>

<style module lang="scss">
  .root {
    max-width: 100% !important;
  }

  .card {
    transition: opacity .3s ease-in-out, transform .3s ease-in-out;
  }

  :global(.VueCarousel-slide) {
    .card {
      transform: scale(.8);
      opacity: .5
    }
  }

  :global(.VueCarousel-slide-active) {
    .card {
      transform: scale(1);
      opacity: 1
    }
  }

  :global {
    .VueCarousel-navigation-button {
      padding: 0 !important;
      outline: none !important;
      background-color: $light !important;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      cursor: pointer;
      box-shadow: 0 2px 4px 0 rgba(208, 208, 208, 0.5);

      &:not(.VueCarousel-navigation--disabled) {
        &:active {
          opacity: .7;
        }
      }
    }

    .VueCarousel-navigation-prev {
      left: 50px !important;
    }

    .VueCarousel-navigation-next {
      right: 50px !important;
    }
  }
</style>
